// CopyMergeAdjustmentReasonCodeList.js  
import React, { useState, useEffect, useMemo } from 'react';  
import { useLocation } from 'react-router-dom';  
import useCustomNavigate from '../../common_nextgen/common_components/Navigation/NextGenNavigation';  
import Form from '../../common_nextgen/common_components/form/Form';  
import { PRICE_SCHEDULE_MODES, isAddMode, isEditMode, isReadOnlyMode } from '../../common_nextgen/utils/Constants';  
import { useAxios } from '../../common_nextgen/axios/AxiosHelper';  
import { useToast } from '../../common_nextgen/hooks/ToastContext';  
import FunctionKeys from '../../common_nextgen/common_components/FunctionKeys/FunctionKeys';  
import { formFields } from './CopyMergeAdjustmentReasonCodeListConfig';  
import { screenInfo } from './CopyMergeAdjustmentReasonCodeListConfig'; 
import {ROUTE_PATHS, externalProgram} from '../../common_nextgen/utils/Constants';

const { ADJUSTMENT_REASON_CODE_LIST} = ROUTE_PATHS;
  
const CopyMergeAdjustmentReasonCodeList = ({ mode }) => {  
  const location = useLocation();  
  
    const { state: stateVal } = location;
    let [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];

    console.log("********************************");
  console.log("currentState - ", currentState);
  console.log("********************************");

    let {
        selectedPriceSchedules = [],
        previousScreen = ADJUSTMENT_REASON_CODE_LIST,
        formData,
        currentIndex: initialIndex = 0,
        scheduleName = "",
        initialParamsData={},
      } = currentState;

  const { axios_helper_no_header } = useAxios();

  // const { selectedPriceSchedules = [{ ad1AdjReasonCodeList: "LIST001", ad1AdjRsnCdeLstDesc: "Description 1" }, { ad1AdjReasonCodeList: "LIST002", ad1AdjRsnCdeLstDesc: "Description 2" }, { ad1AdjReasonCodeList: "LIST001", ad1AdjRsnCdeLstDesc: "Description 3" }], previousScreen = '/adjustment-reason-code-list', currentIndex: initialIndex = 0 } = location.state || {};

  const navigateToPage = useCustomNavigate();  
  const [currentIndex, setCurrentIndex] = useState(initialIndex);  
  const [currentMode, setCurrentMode] = useState(mode);  
//   const [initialFormData, setInitialFormData] = useState({});  
  const [constraintErrors, setConstraintErrors] = useState([]);  
  const toast = useToast();  
  const [initialFormData,setInitialFormData] = useState(useMemo(() => {
    const { ad1AdjReasonCodeList: ad1AdjReasonCodeList = "", ad1AdjRsnCdeLstDesc: ad1AdjRsnCdeLstDesc = "" } = selectedPriceSchedules[currentIndex];
    return { ad1AdjReasonCodeList, ad1AdjRsnCdeLstDesc }
  }, [selectedPriceSchedules, currentIndex]
  ));

  const fetchLookupData = (lookupScreen, params, formData)=>{
            
    navigateToPage(ROUTE_PATHS[externalProgram[lookupScreen]] , [
      
        ...previousState,
      { ...currentState,formData, currentIndex },
      {
        previousScreen: location.pathname,
        selectMode:true,
        params,
      }
      ]);
}
  
  // const handleBack = () => {  
  //   if (currentIndex < selectedPriceSchedules.length - 1) {  
  //     setCurrentIndex(currentIndex + 1);  
  //   } else {  
  //     navigateToPage(previousScreen, { priceSchedule: selectedPriceSchedules[currentIndex] });  
  //   }  
  // };  

  const handleBack = () => {
    if (currentIndex < selectedPriceSchedules.length - 1) {
        setCurrentIndex(currentIndex + 1);
    } else {
      const lastScheduleName= selectedPriceSchedules[currentIndex]?.ad1AdjReasonCodeList;
      const updatedParamsData = {
        ...currentState.paramsData,
        ad1AdjReasonCodeList: lastScheduleName,
      };
        navigateToPage(previousScreen,  [
          ...previousState,
          {
            paramsData: updatedParamsData,
            currentIndex: currentIndex,
          },
        ]);
    }
};
  
  const getPageTitle = () => {  
    const { screenTitle, screenNumber } = screenInfo;  
    return (  
    <>
      <span className="title">{screenTitle}
      </span>  
      <span>{'-'}</span>  
      <span className="screen-number">{screenNumber}</span> 
      </> 
    );  
  };  
  
  const submitForm = async (dataForSubmission) => {  
    const data = { ...dataForSubmission, screenNumber: screenInfo.screenNumber };  
    const url = 'api/ad1AdjReasonCodeList/copy';  
    const verb = 'POST';  
  
    try {  
      const { responseStatus } = await axios_helper_no_header(verb, url, data, null);  
      toast.current.show({  
        severity: "success",  
        summary: "",  
        detail: responseStatus.message,  
        life: 3000  
      }); 

      selectedPriceSchedules[currentIndex].ad1AdjReasonCodeList = data.adjustmentReasonCdeLst; 

    } catch (error) {  
      const { responseStatus: { displayErrorFields = null, message } } = error.data;  
      if (displayErrorFields === null) {  
        toast.current.show({  
          severity: "error",  
          summary: "",  
          detail: message,  
          life: 3000  
        }); 
        } else {  
        setConstraintErrors(displayErrorFields);  
      }  
    }  
  };  
  
  const [keyFunc, keyName] = useMemo(() => {  
    const keyFunc = {};  
    const keyName = {};  
  
    keyFunc['F12'] = handleBack;  
    keyName['F12'] = 'Back';  
  
    return [keyFunc, keyName];  
  }, [currentIndex]);  
  
//   useEffect(() => {  
//     const fetchInitialData = async () => {  
//       const url = 'api/priceschedule/' + selectedPriceSchedules[currentIndex];  
//       try {  
//         const { responseData } = await axios_helper_no_header('GET', url, null);  
//         setInitialFormData(responseData);  
//       } catch (error) {  
//         const { responseStatus: { message } } = error.data;  
//         toast.current.show({  
//           severity: "error",  
//           summary: "",  
//           detail: message,  
//           life: 3000  
//         });  
//       }  
//     };  
//     fetchInitialData();  
//   }, [currentIndex]);  

useEffect(() => {
  console.log("********************************");
  console.log("currentState - ", currentState);
  console.log("********************************");
  setInitialFormData({...initialFormData,...initialParamsData});

  
},[currentIndex])

  
  return (  
    <div className="grid container">  
      <div className="col col-12">  
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />  
      </div>  
      <div className="col col-12">  
        <h1>{getPageTitle()}</h1>  
      </div>  
      <div className="col col-12">  
        <Form formData={initialFormData} formFields={formFields} mode={mode} submitFormData={submitForm} constraintErrors={constraintErrors} 
        fetchLookupData={fetchLookupData}
        />  
      </div>  
    </div>  
  );  
};  
  
export default CopyMergeAdjustmentReasonCodeList;  
